import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import {
  UpdateUserSettingsPayload,
  UserSettings,
  UserSettingsDTO,
  userSettingsSchema,
} from '@optical/types';

@Injectable({ providedIn: 'root' })
export class UserSettingsService {
  private readonly http = inject(HttpClient);

  async getUserSettings(): Promise<UserSettings> {
    const response = await firstValueFrom(this.http.get<UserSettingsDTO>('/user-settings'));

    return userSettingsSchema.decode(response);
  }

  async updateUserSettings(payload: UpdateUserSettingsPayload): Promise<UserSettings> {
    const response = await firstValueFrom(
      this.http.put<UserSettingsDTO>('/user-settings', payload),
    );

    return userSettingsSchema.decode(response);
  }
}
